
import React, { useEffect } from 'react';

const PaymentScript: React.FC = () => {
  useEffect(() => {
    // Add Flutterwave script if it doesn't exist
    if (!document.getElementById('flutterwave-script')) {
      const script = document.createElement('script');
      script.src = 'https://checkout.flutterwave.com/v3.js';
      script.id = 'flutterwave-script';
      script.async = true;
      document.body.appendChild(script);
      
      return () => {
        // Clean up on unmount
        const scriptElement = document.getElementById('flutterwave-script');
        if (scriptElement) {
          document.body.removeChild(scriptElement);
        }
      };
    }
  }, []);

  return null;
};

export default PaymentScript;
